import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  PARTNER_PORTAL_LEADERSHIP_PIPELINE,
  PARTNER_PORTAL_MY_PROJECTS,
  PARTNER_PORTAL_PARTNER_COMPANIES,
  PARTNER_PORTAL_PAE_OPERATIONS,
  PARTNER_PORTAL_PAE_QUEUE,
  PARTNER_PORTAL_SUBMIT,
} from '../Constants/partnerRoutes';

const PartnerSidebar = ({ access }) => {
  const location = useLocation();

  const partnerItems = [
    ...(access.canAccessSubmitProject ? [{ label: 'Submit Project', path: PARTNER_PORTAL_SUBMIT }] : []),
    ...(access.canAccessPartnerPages ? [{ label: 'My Projects', path: PARTNER_PORTAL_MY_PROJECTS }] : []),
  ];

  const paeItems = [
    { label: 'PAE Queue', path: PARTNER_PORTAL_PAE_QUEUE },
    { label: 'Partner Companies', path: PARTNER_PORTAL_PARTNER_COMPANIES },
    { label: 'PAE Operations', path: PARTNER_PORTAL_PAE_OPERATIONS },
  ];
  const leadershipItems = [{ label: 'Leadership Dashboard', path: PARTNER_PORTAL_LEADERSHIP_PIPELINE }];

  const sections = [];

  if (access.canAccessPartnerPages || access.canAccessSubmitProject) {
    sections.push({ heading: 'Delivery Services Hub', items: partnerItems });
  }

  if (access.canPerformPAEOperations) {
    sections.push({ heading: 'PAE Operations', items: paeItems });
  }

  if (access.canAccessLeadershipPages) {
    sections.push({ heading: 'Leadership', items: leadershipItems });
  }

  const isItemActive = (item) => {
    if (item.matchBase) {
      return location.pathname === item.matchBase || location.pathname.startsWith(`${item.matchBase}/`);
    }

    return location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);
  };

  return (
    <aside className="partner-sidebar">
      <div className="partner-sidebar-sections">
        {sections.map((section) => (
          <div className="partner-sidebar-section" key={section.heading}>
            <p className="partner-sidebar-section-title">{section.heading}</p>
            <ul className="partner-sidebar-list">
              {section.items.map((item) => (
                <li key={item.path}>
                  <Link className={isItemActive(item) ? 'active' : ''} to={item.path}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default PartnerSidebar;
